import { render, staticRenderFns } from "./IrisFloatingActionButton.vue?vue&type=template&id=3ecde673&"
import script from "./IrisFloatingActionButton.vue?vue&type=script&lang=ts&"
export * from "./IrisFloatingActionButton.vue?vue&type=script&lang=ts&"
import style0 from "./IrisFloatingActionButton.vue?vue&type=style&index=0&id=3ecde673&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports